import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableutils
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TableWalker from './tablewalker';
import { createEmptyTableCell, updateNumericAttribute } from './commands/utils';
/**
 * The table utilities plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableUtils =
/*#__PURE__*/
function (_Plugin) {
  _inherits(TableUtils, _Plugin);

  function TableUtils() {
    _classCallCheck(this, TableUtils);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableUtils).apply(this, arguments));
  }

  _createClass(TableUtils, [{
    key: "getCellLocation",

    /**
     * Returns the table cell location as an object with table row and table column indexes.
     *
     * For instance in the table below:
     *
     *		    0   1   2   3
     *		  +---+---+---+---+
     *		0 | a     | b | c |
     *		  +       +   +---+
     *		1 |       |   | d |
     *		  +---+---+   +---+
     *		2 | e     |   | f |
     *		  +---+---+---+---+
     *
     * the method will return:
     *
     *		const cellA = table.getNodeByPath( [ 0, 0 ] );
     *		editor.plugins.get( 'TableUtils' ).getCellLocation( cellA );
     *		// will return { row: 0, column: 0 }
     *
     *		const cellD = table.getNodeByPath( [ 1, 0 ] );
     *		editor.plugins.get( 'TableUtils' ).getCellLocation( cellD );
     *		// will return { row: 1, column: 3 }
     *
     * @param {module:engine/model/element~Element} tableCell
     * @returns {Object} Returns a `{row, column}` object.
     */
    value: function getCellLocation(tableCell) {
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var rowIndex = table.getChildIndex(tableRow);
      var tableWalker = new TableWalker(table, {
        startRow: rowIndex,
        endRow: rowIndex
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tableWalker[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _step.value,
              cell = _step$value.cell,
              row = _step$value.row,
              column = _step$value.column;

          if (cell === tableCell) {
            return {
              row: row,
              column: column
            };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    /**
     * Creates an empty table with proper structure. The table needs to be inserted into the model,
     * ie. using {@link module:engine/model/model~Model#insertContent} function.
     *
     *		model.change( ( writer ) => {
     *			// Create a table of 2 rows and 7 columns:
     *			const table = tableUtils.createTable( writer, 2, 7);
     *
     *			// Insert table to the model at the best position taking current selection:
     *			model.insertContent( table );
     *		}
     *
     * @param {module:engine/model/writer~Writer} writer The model writer.
     * @param {Number} rows The number of rows to create.
     * @param {Number} columns The number of columns to create.
     * @returns {module:engine/model/element~Element} The created table element.
     */

  }, {
    key: "createTable",
    value: function createTable(writer, rows, columns) {
      var table = writer.createElement('table');
      createEmptyRows(writer, table, 0, rows, columns);
      return table;
    }
    /**
     * Inserts rows into a table.
     *
     *		editor.plugins.get( 'TableUtils' ).insertRows( table, { at: 1, rows: 2 } );
     *
     * Assuming the table on the left, the above code will transform it to the table on the right:
     *
     *		row index
     *		  0 +---+---+---+       `at` = 1,      +---+---+---+ 0
     *		    | a | b | c |       `rows` = 2,    | a | b | c |
     *		  1 +   +---+---+   <-- insert here    +   +---+---+ 1
     *		    |   | d | e |                      |   |   |   |
     *		  2 +   +---+---+       will give:     +   +---+---+ 2
     *		    |   | f | g |                      |   |   |   |
     *		  3 +---+---+---+                      +   +---+---+ 3
     *		                                       |   | d | e |
     *		                                       +---+---+---+ 4
     *		                                       +   + f | g |
     *		                                       +---+---+---+ 5
     *
     * @param {module:engine/model/element~Element} table The table model element where the rows will be inserted.
     * @param {Object} options
     * @param {Number} [options.at=0] Row index at which the rows will be inserted.
     * @param {Number} [options.rows=1] The number of rows to insert.
     */

  }, {
    key: "insertRows",
    value: function insertRows(table) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var model = this.editor.model;
      var insertAt = options.at || 0;
      var rowsToInsert = options.rows || 1;
      model.change(function (writer) {
        var headingRows = table.getAttribute('headingRows') || 0; // Inserting rows inside heading section requires to update `headingRows` attribute as the heading section will grow.

        if (headingRows > insertAt) {
          writer.setAttribute('headingRows', headingRows + rowsToInsert, table);
        } // Inserting at the end and at the beginning of a table doesn't require to calculate anything special.


        if (insertAt === 0 || insertAt === table.childCount) {
          createEmptyRows(writer, table, insertAt, rowsToInsert, _this.getColumns(table));
          return;
        } // Iterate over all rows above inserted rows in order to check for rowspanned cells.


        var tableIterator = new TableWalker(table, {
          endRow: insertAt
        }); // Will hold number of cells needed to insert in created rows.
        // The number might be different then table cell width when there are rowspanned cells.

        var cellsToInsert = 0;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = tableIterator[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _step2$value = _step2.value,
                row = _step2$value.row,
                rowspan = _step2$value.rowspan,
                colspan = _step2$value.colspan,
                cell = _step2$value.cell;
            var isBeforeInsertedRow = row < insertAt;
            var overlapsInsertedRow = row + rowspan > insertAt;

            if (isBeforeInsertedRow && overlapsInsertedRow) {
              // This cell overlaps inserted rows so we need to expand it further.
              writer.setAttribute('rowspan', rowspan + rowsToInsert, cell);
            } // Calculate how many cells to insert based on the width of cells in a row at insert position.
            // It might be lower then table width as some cells might overlaps inserted row.
            // In the table above the cell 'a' overlaps inserted row so only two empty cells are need to be created.


            if (row === insertAt) {
              cellsToInsert += colspan;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        createEmptyRows(writer, table, insertAt, rowsToInsert, cellsToInsert);
      });
    }
    /**
     * Inserts columns into a table.
     *
     *		editor.plugins.get( 'TableUtils' ).insertColumns( table, { at: 1, columns: 2 } );
     *
     * Assuming the table on the left, the above code will transform it to the table on the right:
     *
     *		0   1   2   3                   0   1   2   3   4   5
     *		+---+---+---+                   +---+---+---+---+---+
     *		| a     | b |                   | a             | b |
     *		+       +---+                   +               +---+
     *		|       | c |                   |               | c |
     *		+---+---+---+     will give:    +---+---+---+---+---+
     *		| d | e | f |                   | d |   |   | e | f |
     *		+---+   +---+                   +---+---+---+   +---+
     *		| g |   | h |                   | g |   |   |   | h |
     *		+---+---+---+                   +---+---+---+---+---+
     *		| i         |                   | i                 |
     *		+---+---+---+                   +---+---+---+---+---+
     *		    ^---- insert here, `at` = 1, `columns` = 2
     *
     * @param {module:engine/model/element~Element} table The table model element where the columns will be inserted.
     * @param {Object} options
     * @param {Number} [options.at=0] Column index at which the columns will be inserted.
     * @param {Number} [options.columns=1] The number of columns to insert.
     */

  }, {
    key: "insertColumns",
    value: function insertColumns(table) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var model = this.editor.model;
      var insertAt = options.at || 0;
      var columnsToInsert = options.columns || 1;
      model.change(function (writer) {
        var headingColumns = table.getAttribute('headingColumns'); // Inserting columns inside heading section requires to update `headingColumns` attribute as the heading section will grow.

        if (insertAt < headingColumns) {
          writer.setAttribute('headingColumns', headingColumns + columnsToInsert, table);
        }

        var tableColumns = _this2.getColumns(table); // Inserting at the end and at the beginning of a table doesn't require to calculate anything special.


        if (insertAt === 0 || tableColumns === insertAt) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = table.getChildren()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var tableRow = _step3.value;
              createCells(columnsToInsert, writer, writer.createPositionAt(tableRow, insertAt ? 'end' : 0));
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          return;
        }

        var tableWalker = new TableWalker(table, {
          column: insertAt,
          includeSpanned: true
        });
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = tableWalker[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _step4$value = _step4.value,
                row = _step4$value.row,
                cell = _step4$value.cell,
                cellIndex = _step4$value.cellIndex;
            // When iterating over column the table walker outputs either:
            // - cells at given column index (cell "e" from method docs),
            // - spanned columns (spanned cell from row between cells "g" and "h" - spanned by "e", only if `includeSpanned: true`),
            // - or a cell from the same row which spans over this column (cell "a").
            var rowspan = parseInt(cell.getAttribute('rowspan') || 1);
            var colspan = parseInt(cell.getAttribute('colspan') || 1);

            if (cell.index !== insertAt && colspan > 1) {
              // If column is different than `insertAt`, it is a cell that spans over an inserted column (cell "a" & "i").
              // For such cells expand them by a number of columns inserted.
              writer.setAttribute('colspan', colspan + columnsToInsert, cell); // The `includeSpanned` option will output the "empty"/spanned column so skip this row already.

              tableWalker.skipRow(row); // This cell will overlap cells in rows below so skip them also (because of `includeSpanned` option) - (cell "a")

              if (rowspan > 1) {
                for (var i = row + 1; i < row + rowspan; i++) {
                  tableWalker.skipRow(i);
                }
              }
            } else {
              // It's either cell at this column index or spanned cell by a rowspanned cell from row above.
              // In table above it's cell "e" and a spanned position from row below (empty cell between cells "g" and "h")
              var insertPosition = writer.createPositionAt(table.getChild(row), cellIndex);
              createCells(columnsToInsert, writer, insertPosition);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      });
    }
    /**
     * Divides a table cell vertically into several ones.
     *
     * The cell will be visually split into more cells by updating colspans of other cells in a column
     * and inserting cells (columns) after that cell.
     *
     * In the table below, if cell "a" is split to 3 cells:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+---+---+---+
     *		| d | e | f |
     *		+---+---+---+
     *
     * it will result in the table below:
     *
     *		+---+---+---+---+---+
     *		| a |   |   | b | c |
     *		+---+---+---+---+---+
     *		| d         | e | f |
     *		+---+---+---+---+---+
     *
     * So cell "d" will get its `colspan` updated to `3` and 2 cells will be added (2 columns will be created).
     *
     * Splitting a cell that already has a `colspan` attribute set will distribute the cell `colspan` evenly and the remainder
     * will be left to the original cell:
     *
     *		+---+---+---+
     *		| a         |
     *		+---+---+---+
     *		| b | c | d |
     *		+---+---+---+
     *
     * Splitting cell "a" with `colspan=3` to 2 cells will create 1 cell with a `colspan=a` and cell "a" that will have `colspan=2`:
     *
     *		+---+---+---+
     *		| a     |   |
     *		+---+---+---+
     *		| b | c | d |
     *		+---+---+---+
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {Number} numberOfCells
     */

  }, {
    key: "splitCellVertically",
    value: function splitCellVertically(tableCell) {
      var numberOfCells = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var model = this.editor.model;
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
      var colspan = parseInt(tableCell.getAttribute('colspan') || 1);
      model.change(function (writer) {
        // First check - the cell spans over multiple rows so before doing anything else just split this cell.
        if (colspan > 1) {
          // Get spans of new (inserted) cells and span to update of split cell.
          var _breakSpanEvenly = breakSpanEvenly(colspan, numberOfCells),
              newCellsSpan = _breakSpanEvenly.newCellsSpan,
              updatedSpan = _breakSpanEvenly.updatedSpan;

          updateNumericAttribute('colspan', updatedSpan, tableCell, writer); // Each inserted cell will have the same attributes:

          var newCellsAttributes = {}; // Do not store default value in the model.

          if (newCellsSpan > 1) {
            newCellsAttributes.colspan = newCellsSpan;
          } // Copy rowspan of split cell.


          if (rowspan > 1) {
            newCellsAttributes.rowspan = rowspan;
          }

          var cellsToInsert = colspan > numberOfCells ? numberOfCells - 1 : colspan - 1;
          createCells(cellsToInsert, writer, writer.createPositionAfter(tableCell), newCellsAttributes);
        } // Second check - the cell has colspan of 1 or we need to create more cells then the currently one spans over.


        if (colspan < numberOfCells) {
          var _cellsToInsert = numberOfCells - colspan; // First step: expand cells on the same column as split cell.


          var tableMap = _toConsumableArray(new TableWalker(table)); // Get the column index of split cell.


          var _tableMap$find = tableMap.find(function (_ref) {
            var cell = _ref.cell;
            return cell === tableCell;
          }),
              splitCellColumn = _tableMap$find.column; // Find cells which needs to be expanded vertically - those on the same column or those that spans over split cell's column.


          var cellsToUpdate = tableMap.filter(function (_ref2) {
            var cell = _ref2.cell,
                colspan = _ref2.colspan,
                column = _ref2.column;
            var isOnSameColumn = cell !== tableCell && column === splitCellColumn;
            var spansOverColumn = column < splitCellColumn && column + colspan > splitCellColumn;
            return isOnSameColumn || spansOverColumn;
          }); // Expand cells vertically.

          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = cellsToUpdate[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var _step5$value = _step5.value,
                  cell = _step5$value.cell,
                  _colspan = _step5$value.colspan;
              writer.setAttribute('colspan', _colspan + _cellsToInsert, cell);
            } // Second step: create columns after split cell.
            // Each inserted cell will have the same attributes:

          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          var _newCellsAttributes = {}; // Do not store default value in the model.
          // Copy rowspan of split cell.

          if (rowspan > 1) {
            _newCellsAttributes.rowspan = rowspan;
          }

          createCells(_cellsToInsert, writer, writer.createPositionAfter(tableCell), _newCellsAttributes);
          var headingColumns = table.getAttribute('headingColumns') || 0; // Update heading section if split cell is in heading section.

          if (headingColumns > splitCellColumn) {
            updateNumericAttribute('headingColumns', headingColumns + _cellsToInsert, table, writer);
          }
        }
      });
    }
    /**
     * Divides a table cell horizontally into several ones.
     *
     * The cell will be visually split into more cells by updating rowspans of other cells in the row and inserting rows with a single cell
     * below.
     *
     * If in the table below cell "b" is split to 3 cells:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+---+---+---+
     *		| d | e | f |
     *		+---+---+---+
     *
     * It will result in the table below:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+   +---+   +
     *		|   |   |   |
     *		+   +---+   +
     *		|   |   |   |
     *		+---+---+---+
     *		| d | e | f |
     *		+---+---+---+
     *
     * So cells "a" and "b" will get their `rowspan` updated to `3` and 2 rows with a single cell will be added.
     *
     * Splitting a cell that already has a `rowspan` attribute set will distribute the cell `rowspan` evenly and the remainder
     * will be left to the original cell:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+   +---+---+
     *		|   | d | e |
     *		+   +---+---+
     *		|   | f | g |
     *		+   +---+---+
     *		|   | h | i |
     *		+---+---+---+
     *
     * Splitting cell "a" with `rowspan=4` to 3 cells will create 2 cells with a `rowspan=1` and cell "a" will have `rowspan=2`:
     *
     *		+---+---+---+
     *		| a | b | c |
     *		+   +---+---+
     *		|   | d | e |
     *		+---+---+---+
     *		|   | f | g |
     *		+---+---+---+
     *		|   | h | i |
     *		+---+---+---+
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {Number} numberOfCells
     */

  }, {
    key: "splitCellHorizontally",
    value: function splitCellHorizontally(tableCell) {
      var numberOfCells = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var model = this.editor.model;
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var splitCellRow = table.getChildIndex(tableRow);
      var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
      var colspan = parseInt(tableCell.getAttribute('colspan') || 1);
      model.change(function (writer) {
        // First check - the cell spans over multiple rows so before doing anything else just split this cell.
        if (rowspan > 1) {
          // Cache table map before updating table.
          var tableMap = _toConsumableArray(new TableWalker(table, {
            startRow: splitCellRow,
            endRow: splitCellRow + rowspan - 1,
            includeSpanned: true
          })); // Get spans of new (inserted) cells and span to update of split cell.


          var _breakSpanEvenly2 = breakSpanEvenly(rowspan, numberOfCells),
              newCellsSpan = _breakSpanEvenly2.newCellsSpan,
              updatedSpan = _breakSpanEvenly2.updatedSpan;

          updateNumericAttribute('rowspan', updatedSpan, tableCell, writer);

          var _tableMap$find2 = tableMap.find(function (_ref3) {
            var cell = _ref3.cell;
            return cell === tableCell;
          }),
              cellColumn = _tableMap$find2.column; // Each inserted cell will have the same attributes:


          var newCellsAttributes = {}; // Do not store default value in the model.

          if (newCellsSpan > 1) {
            newCellsAttributes.rowspan = newCellsSpan;
          } // Copy colspan of split cell.


          if (colspan > 1) {
            newCellsAttributes.colspan = colspan;
          }

          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = tableMap[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var _step6$value = _step6.value,
                  column = _step6$value.column,
                  row = _step6$value.row,
                  cellIndex = _step6$value.cellIndex;
              // As both newly created cells and the split cell might have rowspan,
              // the insertion of new cells must go to appropriate rows:
              //
              // 1. It's a row after split cell + it's height.
              var isAfterSplitCell = row >= splitCellRow + updatedSpan; // 2. Is on the same column.

              var isOnSameColumn = column === cellColumn; // 3. And it's row index is after previous cell height.

              var isInEvenlySplitRow = (row + splitCellRow + updatedSpan) % newCellsSpan === 0;

              if (isAfterSplitCell && isOnSameColumn && isInEvenlySplitRow) {
                var position = writer.createPositionAt(table.getChild(row), cellIndex);
                createCells(1, writer, position, newCellsAttributes);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        } // Second check - the cell has rowspan of 1 or we need to create more cells than the current cell spans over.


        if (rowspan < numberOfCells) {
          // We already split the cell in check one so here we split to the remaining number of cells only.
          var cellsToInsert = numberOfCells - rowspan; // This check is needed since we need to check if there are any cells from previous rows than spans over this cell's row.

          var _tableMap = _toConsumableArray(new TableWalker(table, {
            startRow: 0,
            endRow: splitCellRow
          })); // First step: expand cells.


          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = _tableMap[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _step7$value = _step7.value,
                  cell = _step7$value.cell,
                  _rowspan = _step7$value.rowspan,
                  _row = _step7$value.row;

              // Expand rowspan of cells that are either:
              // - on the same row as current cell,
              // - or are below split cell row and overlaps that row.
              if (cell !== tableCell && _row + _rowspan > splitCellRow) {
                var rowspanToSet = _rowspan + cellsToInsert;
                writer.setAttribute('rowspan', rowspanToSet, cell);
              }
            } // Second step: create rows with single cell below split cell.

          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          var _newCellsAttributes2 = {}; // Copy colspan of split cell.

          if (colspan > 1) {
            _newCellsAttributes2.colspan = colspan;
          }

          createEmptyRows(writer, table, splitCellRow + 1, cellsToInsert, 1, _newCellsAttributes2); // Update heading section if split cell is in heading section.

          var headingRows = table.getAttribute('headingRows') || 0;

          if (headingRows > splitCellRow) {
            updateNumericAttribute('headingRows', headingRows + cellsToInsert, table, writer);
          }
        }
      });
    }
    /**
     * Returns the number of columns for a given table.
     *
     *		editor.plugins.get( 'TableUtils' ).getColumns( table );
     *
     * @param {module:engine/model/element~Element} table The table to analyze.
     * @returns {Number}
     */

  }, {
    key: "getColumns",
    value: function getColumns(table) {
      // Analyze first row only as all the rows should have the same width.
      var row = table.getChild(0);
      return _toConsumableArray(row.getChildren()).reduce(function (columns, row) {
        var columnWidth = parseInt(row.getAttribute('colspan') || 1);
        return columns + columnWidth;
      }, 0);
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'TableUtils';
    }
  }]);

  return TableUtils;
}(Plugin); // Creates empty rows at the given index in an existing table.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/element~Element} table
// @param {Number} insertAt Row index of row insertion.
// @param {Number} rows Number of rows to create.
// @param {Number} tableCellToInsert Number of cells to insert in each row.


export { TableUtils as default };

function createEmptyRows(writer, table, insertAt, rows, tableCellToInsert) {
  var attributes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  for (var i = 0; i < rows; i++) {
    var tableRow = writer.createElement('tableRow');
    writer.insert(tableRow, table, insertAt);
    createCells(tableCellToInsert, writer, writer.createPositionAt(tableRow, 'end'), attributes);
  }
} // Creates cells at a given position.
//
// @param {Number} columns Number of columns to create
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/position~Position} insertPosition


function createCells(cells, writer, insertPosition) {
  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  for (var i = 0; i < cells; i++) {
    createEmptyTableCell(writer, insertPosition, attributes);
  }
} // Evenly distributes the span of a cell to a number of provided cells.
// The resulting spans will always be integer values.
//
// For instance breaking a span of 7 into 3 cells will return:
//
//		{ newCellsSpan: 2, updatedSpan: 3 }
//
// as two cells will have a span of 2 and the remainder will go the first cell so its span will change to 3.
//
// @param {Number} span Span value do break.
// @param {Number} numberOfCells Number of resulting spans.
// @returns {{newCellsSpan: Number, updatedSpan: Number}}


function breakSpanEvenly(span, numberOfCells) {
  if (span < numberOfCells) {
    return {
      newCellsSpan: 1,
      updatedSpan: 1
    };
  }

  var newCellsSpan = Math.floor(span / numberOfCells);
  var updatedSpan = span - newCellsSpan * numberOfCells + newCellsSpan;
  return {
    newCellsSpan: newCellsSpan,
    updatedSpan: updatedSpan
  };
}